module.exports = __webpack_public_path__ + "assets/Parallel.5da6e48b28007ed18c319d74993217a1.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Parallel.gmt
// module id = 977
// module chunks = 0